import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import axios from "../../../axios";
import Alert from "react-s-alert";
import qs from "qs";
import Paging from "../../../components/Paging";
import { QUESTION_LIST, SCHEDULE_LIST } from "../endpoints";
import BriefScheduleDetail from "./BriefScheduleDetail";
import fp from "lodash/fp";
import CustomModal from "../CustomModal";


class Lists extends React.Component {
	constructor() {
		super();
		this.state = {
			dataQuestion: [],
			dataDetailExam: {},
			jumlahPilihanGanda: 0,
			exam_cat_id: 0,
			pageCount: 0,
			currentPage: 0,
			isLoading: false,
			isDetailExamLoading: false,
			isModalShow: false,
			question_id:""
		};
		this.toggleModal = this.toggleModal.bind(this);

	}

	handlePageClick(data) {
		let selected = data.selected; // zero based index

		this.setState({ currentPage: selected }, () => {
			this.loadData();
		});
	}

	loadData() {
		this.setState({ isLoading: true });

		axios({
			method: "post",
			url: '/exam/exam-list-soal',
			data: qs.stringify({ exam_id: this.props.match.params.exam_id,locale:"id",platform:"web",user_id: localStorage.SISMART_USER_ID})
		})
			.then(response => {
				const result = response.data;
				console.log(result)
				if (result.status === true) {
					this.setState({
						dataQuestion: result.data.type,
						isLoading: false
					});
				} else {
					Alert.error(result.text);
					this.setState({ isLoading: false });
				}
			})
			.catch(error => {
				console.log(error);
				this.setState({ isLoading: false });
				Alert.error("Gagal terhubung ke server!");
			});
	}

	toggleModal(e) {
		this.setState({
			modalShow: !this.state.modalShow,
			question_id : e
		});
	}

	handleHapusButton(a) {
		this.setState({ isButtonLoading: true });

		const url = '/exam/delete-soal'

		let newState = {
			locale:"id",
			platform:"web",
			user_id:localStorage.SISMART_USER_ID,
			question_id:a,
			exam_id:this.props.match.params.exam_id
		};

		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;

			if (result.status) {
				Alert.success(result.text);
				this.props.history.replace(
					"/exam/question/" + this.props.match.params.exam_id
				);
			} else {
				if (Array.isArray(result.text)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});

		this.setState({ modalShow: false });
		window.location.reload()
	}

	loadDetailExam() {
		this.setState({ isDetailExamLoading: true });

		axios({
			method: "post",
			url: 'exam/detail-exam',
			data: qs.stringify({ exam_id: this.props.match.params.exam_id,locale:"id",platform:"web",user_id: localStorage.SISMART_USER_ID})
		})
			.then(response => {
				const result = response.data;

				if (result.status) {
					this.setState({
						dataDetailExam: result.data.exam
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isDetailExamLoading: false });
			})
			.catch(error => {
				console.log(error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isDetailExamLoading: false });
			});
	}


	componentDidMount() {
		if(localStorage.SISMART_USER_LEVEL !=='administrator'){
			this.props.history.replace("/dashboard");
        }
		this.loadData();
		this.loadDetailExam();
	}

	render() {
		return (
			<div>
				<CustomModal
					modalHeaderText="Hapus"
					modalBodyText="Anda yakin ingin menghapus?"
					modalSubmitText="Hapus"
					handleSubmit={() => this.handleHapusButton(this.state.question_id)}
					toggleModal={this.toggleModal}
					isShow={this.state.modalShow}
				/>
				<div className="card">
					<div className="card-header">
						<div style={{ marginTop: "10px", display: "inline-block" }}>
							Data Pertanyaan
						</div>
						<NavLink
							to={`${this.props.match.url}/add`}
							className="btn btn-primary pull-right"
							style={{ marginTop: "2px" }}
						>
							Tambah Pertanyaan
						</NavLink>
						<NavLink
							to={`/exam/schedule`}
							className="btn btn-secondary pull-right"
							style={{ marginTop: "2px", marginRight: "5px" }}
						>
							<i className="fa fa-chevron-left" /> Kembali ke list
						</NavLink>
					</div>
					<div className="card-header">
						<div Class="card-body">
							<table className="table table-striped table-bordered animated fadeIn">
								<tr>
									<td>Judul </td>
									<td>{this.state.dataDetailExam.exam_title}</td>
								</tr>
								<tr>
									<td>Deskripsi </td>
									<td>{this.state.dataDetailExam.exam_desc}</td>
								</tr>
								<tr>
									<td>Tanggal Mulai </td>
									<td>{this.state.dataDetailExam.exam_start_date}</td>
								</tr>
								<tr>
									<td>Tanggal Selesai </td>
									<td>{this.state.dataDetailExam.exam_end_date}</td>
								</tr>
								<tr>
									<td>Durasi </td>
									<td>{this.state.dataDetailExam.exam_time_limit}</td>
								</tr>
								<tr>
									<td>Soal </td>
									<td>{this.state.dataDetailExam.exam_question_count}</td>
								</tr>
							</table>
						</div>
					</div>
					<div className="card">
						{this.state.isLoading ? (
							"Memuat Data..."
						) : this.state.dataQuestion.length === 0 ? (
							"Data Kosong..."
						) : (
							<div>
								<table className="table table-striped table-bordered animated fadeIn">
										{this.state.dataQuestion.map((item, i) => {
											return (
													<tbody>
													<tr>
														<th colspan={3}>{item.question_type.toLocaleUpperCase()}</th>
													</tr>
													<tr>
														<td colspan={3}>
															<div className="card-block">
																{item.question.length === 0 ? (
																	"Data Kosong..."
																) : (
																	<div>
																		<table className="table table-striped table-bordered animated fadeIn">
																			<thead>
																				<tr>
																					<th width={25}>No</th>
																					<th>Pertanyaan</th>
																					<th width={200}>Opsi</th>
																				</tr>
																			</thead>
																			<tbody>
																				{item.question.map((itemQues, i) => {
																					return (
																						<tr key={itemQues.question_id}>
																							<td>{i + 1}</td>
																							<td>
																								{itemQues.question_text}
																								<p style={{ marginBottom: 5 }} />
																								{itemQues.question_type == 'essay' ? (
																									"Essay..."
																								) : (
																									itemQues.question_type == 'match' ? (
																										itemQues.option.map((itemx, i) => (
																											<div
																												className="checkbox"
																												key={`pilihanGanda-${itemx.question_id}-${i}`}
																											>
																												<input
																													type="checkbox"
																													value="option1"
																													checked={itemx.score != null}
																													style={{ marginRight: 5 }}
																													disabled
																												/>
																												{itemx.option_text+" "} 
																												<i className="fa fa-arrows-h fa-lg mt-4"></i>
																												{" "+itemx.option_match_text}
																											</div>
																										))
																									) : (
																										itemQues.option.map((itemx, i) => (
																											<div
																												className="radio"
																												key={`pilihanGanda-${itemx.question_id}-${i}`}
																											>
																												<input
																													type="radio"
																													value="option1"
																													checked={itemx.score != null}
																													style={{ marginRight: 5 }}
																													disabled
																												/>
																												{itemx.option_text}
																											</div>
																										))
																									)
																								)
																								}
																							</td>
																							<td>
																								<NavLink
																									to={`${this.props.match.url}/edit/${
																										itemQues.question_id
																									}`}
																									className="btn btn-secondary btn-sm"
																								>
																									Edit
																								</NavLink>
																								<button
																									onClick={() => this.toggleModal(itemQues.question_id)}
																									className="btn btn-secondary btn-sm"
																								>
																									Hapus
																								</button>
																							</td>
																						</tr>
																					);
																				})}
																			</tbody>
																		</table>
																	</div>
																)}
															</div>
														</td>
													</tr>
													</tbody>
												)
											}
										)
									}
								</table>
								<Paging
									handlePageClick={this.handlePageClick.bind(this)}
									pageCount={this.state.pageCount}
									currentPage={this.state.currentPage}
								/>
							</div>
						)}
					</div>
					
				</div>
			</div>
		);
	}
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Exam/Question/Lists.js